export default __webpack_public_path__ + "static/media/kahve.b1545478.mp3";